import { type ToastType, useToastStore } from "@shared/store/toastStore";
import { AlertTriangle, CheckCircle, Info, X, XCircle } from "lucide-react";
import { createPortal } from "react-dom";
import "./_toaster.scss";

const MAX_VISIBLE = 5;

const ICONS: Record<ToastType, React.ComponentType<{ size?: number }>> = {
	success: CheckCircle,
	error: XCircle,
	warning: AlertTriangle,
	info: Info,
};

export const Toaster = () => {
	const toasts = useToastStore((s) => s.toasts);
	const dismiss = useToastStore((s) => s.dismiss);

	const visible = toasts.slice(-MAX_VISIBLE);

	if (visible.length === 0) return null;

	return createPortal(
		<section className="toaster" aria-label="Notifications">
			{visible.map((t) => {
				const Icon = ICONS[t.type];
				return (
					<div
						key={t.id}
						className={`toaster__item toaster__item--${t.type}`}
						role="status"
					>
						<span className="toaster__icon">
							<Icon size={20} />
						</span>
						<p className="toaster__message">{t.message}</p>
						<button
							type="button"
							className="toaster__close"
							onClick={() => dismiss(t.id)}
							aria-label="Dismiss notification"
						>
							<X size={16} />
						</button>
					</div>
				);
			})}
		</section>,
		document.body,
	);
};
